import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2"; 
import "../../styles/Admin.css";
import axios from "axios";

const LogistikP = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [purchaseData, setPurchaseData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [tanggal, setTanggal] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  // Helper konversi waktu UTC/GMT ke GMT+7 (Asia/Jakarta)
  const formatToWIB = (dateString, withTime = false) => {
    if (!dateString || dateString === "-") return "-";

    let isoString = String(dateString).trim();
    if (!isoString.endsWith("Z") && !isoString.includes("+")) {
      isoString = isoString.replace(" ", "T") + "Z";
    }

    const date = new Date(isoString);
    if (isNaN(date.getTime())) return dateString;

    const options = {
      timeZone: "Asia/Jakarta",
      day: "numeric",
      month: "short",
      year: "numeric",
      ...(withTime && {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }),
    };

    return new Intl.DateTimeFormat("id-ID", options).format(date) + (withTime ? " WIB" : "");
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    fetchPurchaseData();
  }, []);

  const fetchPurchaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/riwayat",
        { withCredentials: true }
      );

      if (response.status === 200) {
        setPurchaseData(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire("Error", "Gagal memuat data riwayat pengiriman.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleLogistikpr = () => {
    navigate("/logistikpr");
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout error fallback:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const handleDetailPengiriman = async (trackingId) => {
    try {
      const res = await axios.get(
        `https://c-greenproject.org:7500/detail_pengiriman_logistik?tracking_id=${trackingId}`,
        { withCredentials: true }
      );

      const d = res.data.detail;
      if (!d) {
        Swal.fire("Error", "Detail pengiriman tidak ditemukan.", "error");
        return;
      }

      const petani = d.asal_petani || {};
      const pabrik = d.tujuan_pabrik || {};
      const timbangan = d.timbangan || {};
      const driverList = d.armada_driver || [];

      Swal.fire({
        title: `<div class="text-center pt-2 pb-2 border-bottom"><h5 class="fw-bold m-0 text-success"><i class="fa fa-truck me-2"></i>Rincian Pengiriman #${d.tracking_id}</h5></div>`,
        width: "740px",
        background: "#ffffff",
        confirmButtonText: "Tutup",
        confirmButtonColor: "#198754",
        customClass: {
          popup: "rounded-4 shadow-lg border-0 p-4",
          confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        },
        html: `
          <div style="text-align: left; font-size: 13.5px; color: #374151; margin-top: 14px;">
            
            <div style="background: #f8fafc; padding: 14px; border-radius: 12px; margin-bottom: 12px; border: 1px solid #e2e8f0;">
              <h6 style="font-weight: 700; color: #0f766e; margin-bottom: 10px; font-size: 13.5px;">⚖️ Status & Parameter Timbangan Sawit</h6>
              <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px;">
                <div>
                  <small style="color: #64748b; font-size: 11px; display: block;">BERAT AWAL</small>
                  <strong style="font-size: 13px;">${timbangan.berat_awal ? Number(timbangan.berat_awal).toLocaleString("id-ID") + " Kg" : "-"}</strong>
                </div>
                <div>
                  <small style="color: #64748b; font-size: 11px; display: block;">BERAT AKHIR (PABRIK)</small>
                  <strong class="text-success" style="font-size: 13px;">${timbangan.berat_akhir ? Number(timbangan.berat_akhir).toLocaleString("id-ID") + " Kg" : "-"}</strong>
                </div>
                <div>
                  <small style="color: #64748b; font-size: 11px; display: block;">TGL PENGIRIMAN</small>
                  <span style="font-size: 12.5px;">${formatToWIB(d.tanggal_pengiriman)}</span>
                </div>
                <div>
                  <small style="color: #64748b; font-size: 11px; display: block;">TGL DITERIMA</small>
                  <span style="font-size: 12.5px;">${formatToWIB(d.tanggal_diterima)}</span>
                </div>
              </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px;">
              <div style="background: #f8fafc; padding: 14px; border-radius: 12px; border: 1px solid #e2e8f0;">
                <h6 style="font-weight: 700; color: #198754; margin-bottom: 8px; font-size: 13px;">📍 Asal Penjemputan (Petani)</h6>
                <div><small style="color: #64748b; font-size: 11px;">Nama Petani:</small> <strong class="text-dark d-block">${petani.nama || "-"}</strong></div>
                <div class="mt-1"><small style="color: #64748b; font-size: 11px;">Kontak:</small> <strong class="text-primary font-monospace d-block">📞 ${petani.nomor_hp || "-"}</strong></div>
                <div class="mt-1"><small style="color: #64748b; font-size: 11px;">Alamat Lahan:</small> <span class="d-block text-secondary small">${petani.alamat_jemput || "-"}</span></div>
              </div>

              <div style="background: #f8fafc; padding: 14px; border-radius: 12px; border: 1px solid #e2e8f0;">
                <h6 style="font-weight: 700; color: #0284c7; margin-bottom: 8px; font-size: 13px;">🏭 Tujuan Pengantaran (Pabrik)</h6>
                <div><small style="color: #64748b; font-size: 11px;">Nama Pabrik:</small> <strong class="text-dark d-block">${pabrik.nama || "-"}</strong></div>
                <div class="mt-1"><small style="color: #64748b; font-size: 11px;">Kontak Pabrik:</small> <strong class="text-primary font-monospace d-block">📞 ${pabrik.nomor_hp || "-"}</strong></div>
                <div class="mt-1"><small style="color: #64748b; font-size: 11px;">Alamat Pabrik:</small> <span class="d-block text-secondary small">${pabrik.alamat || "-"}</span></div>
              </div>
            </div>

            <div style="background: #f8fafc; padding: 14px; border-radius: 12px; border: 1px solid #e2e8f0;">
              <h6 style="font-weight: 700; color: #475569; margin-bottom: 8px; font-size: 13px;">🚚 Data Driver & Posisi Terakhir</h6>
              ${
                driverList.length > 0
                  ? `
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-0" style="font-size: 12px; background: white;">
                    <thead class="table-light">
                      <tr>
                        <th>Driver</th>
                        <th>Plat Truk</th>
                        <th>Status</th>
                        <th>Lokasi Terakhir</th>
                        <th>Waktu Update</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${driverList
                        .map(
                          (drv) => `
                        <tr>
                          <td><strong>${drv.nama_driver || "-"}</strong></td>
                          <td class="font-monospace">${drv.plat_truk || "-"}</td>
                          <td><span class="badge bg-primary-subtle text-primary border">${drv.status || "-"}</span></td>
                          <td>${drv.lokasi || "-"}</td>
                          <td class="text-muted">${formatToWIB(drv.waktu_update, true)}</td>
                        </tr>
                      `
                        )
                        .join("")}
                    </tbody>
                  </table>
                </div>
              `
                  : `<span class="text-muted fst-italic small">Belum ada armada/driver yang ditugaskan.</span>`
              }
            </div>

          </div>
        `,
      });
    } catch (error) {
      console.error("Error load detail pengiriman:", error);
      Swal.fire("Error", "Gagal memuat rincian detail pengiriman.", "error");
    }
  };

  const handlePermohonanClick = async () => {
    try {
      const response = await axios.get(
        "https://c-greenproject.org:7500/lihat_permohonan_pengiriman",
        { withCredentials: true }
      );

      if (
        response.data.permintaan_pengiriman &&
        response.data.permintaan_pengiriman.length > 0
      ) {
        let tableContent = response.data.permintaan_pengiriman
          .map((item, index) => {
            const status = item.status_permohonan || "Pending";
            let badgeClass = "bg-warning-subtle text-warning-emphasis border-warning-subtle";
            if (status.toLowerCase().includes("terima") || status.toLowerCase().includes("disetujui") || status.toLowerCase() === "approved") {
              badgeClass = "bg-success-subtle text-success border-success-subtle";
            } else if (status.toLowerCase().includes("tolak") || status.toLowerCase().includes("batal") || status.toLowerCase() === "rejected") {
              badgeClass = "bg-danger-subtle text-danger border-danger-subtle";
            }

            return `
              <tr>
                <td class="text-center text-muted fw-bold py-2.5 px-3">${index + 1}</td>
                <td class="text-center font-monospace fw-semibold py-2.5 px-3">#${item.id_permohonan}</td>
                <td class="text-center font-monospace py-2.5 px-3">
                  <span class="badge bg-light text-dark border px-2 py-1">${item.tracking_id || "-"}</span>
                </td>
                <td class="py-2.5 px-3 fw-medium text-dark text-capitalize">${item.nama_rencana_panen || "-"}</td>
                <td class="text-center py-2.5 px-3">
                  <span class="badge ${badgeClass} border px-3 py-1.5 rounded-pill fw-semibold" style="font-size: 11px;">
                    ${status}
                  </span>
                </td>
              </tr>
            `;
          })
          .join("");

        Swal.fire({
          title: `<div class="text-center pt-2 pb-2 border-bottom"><h4 class="fw-bold m-0" style="color: #198754; font-family: 'Poppins', sans-serif;"><i class="fa fa-paper-plane me-2"></i>Daftar Permohonan ke Kebun</h4></div>`,
          html: `
            <div class="text-start mt-2" style="font-size: 0.9rem; font-family: 'Poppins', sans-serif; color: #374151;">
              <p class="text-muted small mb-2">Total ${response.data.permintaan_pengiriman.length} permohonan pengiriman armada diajukan ke pihak kebun.</p>
              
              <div class="border rounded-3 shadow-sm" style="max-height: 48vh; overflow-y: auto; overflow-x: auto;">
                <table class="table table-hover table-striped align-middle mb-0" style="font-size: 13px; min-width: 580px;">
                  <thead class="table-light sticky-top" style="position: sticky; top: 0; z-index: 2;">
                    <tr class="text-secondary small fw-semibold">
                      <th class="text-center py-2.5 px-3 bg-light" style="width: 50px;">No</th>
                      <th class="text-center py-2.5 px-3 bg-light">ID Permohonan</th>
                      <th class="text-center py-2.5 px-3 bg-light">Tracking ID</th>
                      <th class="py-2.5 px-3 bg-light">Rencana Panen</th>
                      <th class="text-center py-2.5 px-3 bg-light">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${tableContent}
                  </tbody>
                </table>
              </div>
            </div>
          `,
          width: "780px",
          background: "#ffffff",
          confirmButtonText: "Tutup",
          confirmButtonColor: "#198754",
          showCloseButton: true,
          focusConfirm: false,
          customClass: {
            popup: "rounded-4 shadow-lg border-0 p-4",
            confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
          },
        });
      } else {
        Swal.fire({
          icon: "info",
          title: "Informasi",
          text: "Belum ada permohonan pengiriman yang diajukan ke kebun.",
          confirmButtonColor: "#198754",
          customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
        });
      }
    } catch (error) {
      console.error("Error fetching permohonan:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Terjadi kesalahan saat memuat data permohonan.",
        confirmButtonColor: "#198754",
      });
    }
  };

  const getNormalizedStatus = (rawStatus) => {
    const s = String(rawStatus || "").toLowerCase().trim();
    if (s.includes("selesai") || s.includes("terkirim") || s.includes("diterima") || s.includes("delivered")) {
      return "selesai";
    }
    if (s.includes("pengiriman") || s.includes("transit") || s.includes("jalan") || s.includes("proses")) {
      return "pengiriman";
    }
    if (s.includes("batal") || s.includes("gagal") || s.includes("reject")) {
      return "gagal";
    }
    return "pending";
  };

  const getStatusBadge = (status) => {
    const normalized = getNormalizedStatus(status);
    if (normalized === "selesai") {
      return <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1.5 rounded-pill fw-semibold">Selesai</span>;
    }
    if (normalized === "pengiriman") {
      return <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-1.5 rounded-pill fw-semibold">Dalam Pengiriman</span>;
    }
    if (normalized === "gagal") {
      return <span className="badge bg-danger-subtle text-danger border border-danger-subtle px-3 py-1.5 rounded-pill fw-semibold">Gagal</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-1.5 rounded-pill fw-semibold text-capitalize">{status || "Pending"}</span>;
  };

  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(Number(num))) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  const filteredData = purchaseData.filter((item) => {
    const normalized = getNormalizedStatus(item.status);
    
    let matchStatus = true;
    if (statusFilter !== "all") {
      matchStatus = (normalized === statusFilter);
    }

    const matchSearch =
      (item.tracking_id || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.nama_petani || "").toLowerCase().includes(searchTerm.toLowerCase());

    return matchStatus && matchSearch;
  });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentPurchaseData = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFilterChange = (status) => {
    setStatusFilter(status);
    setCurrentPage(1);
  };

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      {/* Isolasi Style Tabel untuk Mencegah Header Tertimpa */}
      <style>{`
        .custom-delivery-table {
          width: 100% !important;
          border-collapse: collapse !important;
          table-layout: auto !important;
        }
        .custom-delivery-table th,
        .custom-delivery-table td {
          position: static !important;
          float: none !important;
          display: table-cell !important;
          vertical-align: middle !important;
          white-space: nowrap !important;
        }
        .dataTables_paginate,
        .dataTables_info,
        .dataTables_length,
        .dataTables_filter,
        .dataTables_scrollHead {
          display: none !important;
        }
      `}</style>

      {/* Header */}
      <div className="header bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-success btn-sm rounded-pill px-3"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1" style={{ width: "100%", overflowX: "hidden" }}>
        {/* Sidebar */}
        <div className="sidebar p-3" style={{ width: "240px", flexShrink: 0 }}>
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/logistik")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistik" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistik" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/logistikp")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/logistikp" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/logistikp" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/shipping.png" alt="Shipping" /> Pengiriman
            </div>
            <div
              onClick={() => navigate("/logistikrp")}
              className={`list-group-item text-decoration-none ${
                location.pathname.includes("/logistikrp") ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname.includes("/logistikrp") ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div 
          className="flex-grow-1 p-4" 
          style={{ 
            width: "calc(100% - 240px)", 
            minWidth: 0, 
            overflowX: "hidden" 
          }}
        >
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Rincian Pengiriman</h2>
              <p className="text-muted small mb-0">Kelola riwayat pengiriman sawit serta validasi permintaan kebun.</p>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn rounded-pill px-4 shadow-sm fw-semibold"
                style={{
                  color: "#198754",
                  borderColor: "#198754",
                  backgroundColor: "#ffffff",
                  borderWidth: "1.5px",
                  borderStyle: "solid"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#198754";
                  e.currentTarget.style.color = "#ffffff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.color = "#198754";
                }}
                onClick={handlePermohonanClick}
                title="Daftar permohonan yang dikirim ke kebun"
              >
                <i className="fa fa-list-alt me-2"></i>Daftar Permohonan
              </button>
              <button
                className="btn rounded-pill px-4 shadow-sm fw-semibold"
                style={{
                  backgroundColor: "#198754",
                  borderColor: "#198754",
                  color: "#ffffff",
                  borderWidth: "1.5px",
                  borderStyle: "solid"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#157347";
                  e.currentTarget.style.borderColor = "#157347";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#198754";
                  e.currentTarget.style.borderColor = "#198754";
                }}
                onClick={handleLogistikpr}
                title="Validasi permintaan yang dikirim oleh kebun"
              >
                <i className="fa fa-check-circle me-2"></i>Validasi Permintaan Kebun
              </button>
            </div>
          </div>

          <div className="divider mb-4"></div>

          <div className="bg-white rounded-4 border shadow-sm p-4 w-100" style={{ minWidth: 0 }}>
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
              <div>
                <h4 className="fw-bold text-success mb-1">Riwayat Pengiriman Armada</h4>
                <span className="text-muted small">Total: {filteredData.length} data ditemukan</span>
              </div>

              <div className="d-flex flex-wrap align-items-center gap-2">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control rounded-pill px-3 py-2 shadow-none"
                    style={{ fontSize: "0.85rem", width: "210px", borderColor: "#cbd5e1" }}
                    placeholder="Cari Tracking / Petani..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>

                <div className="d-flex align-items-center gap-2">
                  <select
                    className="form-select rounded-pill px-3 py-2 shadow-none fw-medium"
                    style={{ fontSize: "0.85rem", borderColor: "#cbd5e1", minWidth: "175px" }}
                    value={statusFilter}
                    onChange={(e) => handleFilterChange(e.target.value)}
                  >
                    <option value="all">Semua Status</option>
                    <option value="pengiriman">Dalam Pengiriman</option>
                    <option value="selesai">Selesai</option>
                    <option value="pending">Pending</option>
                    <option value="gagal">Gagal / Dibatalkan</option>
                  </select>
                </div>
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data pengiriman...</p>
              </div>
            ) : currentPurchaseData && currentPurchaseData.length > 0 ? (
              <>
                <div className="table-responsive w-100" style={{ overflowX: "auto" }}>
                  <table className="table table-hover align-middle mb-0 custom-delivery-table" style={{ minWidth: "1000px" }}>
                    <thead className="table-light">
                      <tr className="text-secondary small fw-semibold">
                        <th className="text-center py-3 px-2" style={{ width: "50px", borderTopLeftRadius: "10px" }}>No</th>
                        <th className="text-center py-3 px-3" style={{ width: "140px" }}>Tracking ID</th>
                        <th className="py-3 px-3" style={{ width: "180px" }}>Nama Petani</th>
                        <th className="text-end py-3 px-3" style={{ width: "120px" }}>Berat Awal</th>
                        <th className="text-end py-3 px-3" style={{ width: "120px" }}>Berat Akhir</th>
                        <th className="text-center py-3 px-3" style={{ width: "150px" }}>Status</th>
                        <th className="text-center py-3 px-3" style={{ width: "120px" }}>Tgl Kirim</th>
                        <th className="text-center py-3 px-3" style={{ width: "120px" }}>Tgl Terima</th>
                        <th className="text-center py-3 px-3" style={{ width: "100px", borderTopRightRadius: "10px" }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPurchaseData.map((item, index) => (
                        <tr key={`pengiriman-${item.tracking_id || index}`}>
                          <td className="text-center fw-bold text-muted px-2">
                            {startIndex + index + 1}
                          </td>
                          <td className="text-center font-monospace px-3">
                            <span className="badge bg-light text-dark border px-2 py-1">
                              {item.tracking_id || "-"}
                            </span>
                          </td>
                          <td className="fw-semibold text-dark text-capitalize px-3">
                            {item.nama_petani || "-"}
                          </td>
                          <td className="text-end font-monospace text-dark px-3 fw-semibold">
                            {item.berat_awal_sawit ? `${formatNumber(item.berat_awal_sawit)} kg` : "-"}
                          </td>
                          <td className="text-end font-monospace text-success px-3 fw-bold">
                            {item.berat_akhir_sawit ? `${formatNumber(item.berat_akhir_sawit)} kg` : "-"}
                          </td>
                          <td className="text-center text-nowrap px-3">
                            {getStatusBadge(item.status)}
                          </td>
                          <td className="text-center text-muted small text-nowrap px-3">
                            {formatToWIB(item.tanggal_pengiriman)}
                          </td>
                          <td className="text-center text-muted small text-nowrap px-3">
                            {formatToWIB(item.tanggal_diterima)}
                          </td>
                          <td className="text-center px-3">
                            <button
                              className="btn btn-sm rounded-pill px-3 fw-semibold shadow-sm"
                              style={{
                                color: "#198754",
                                borderColor: "#198754",
                                backgroundColor: "#ffffff",
                                borderWidth: "1.5px",
                                borderStyle: "solid",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#198754";
                                e.currentTarget.style.color = "#ffffff";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#ffffff";
                                e.currentTarget.style.color = "#198754";
                              }}
                              onClick={() => handleDetailPengiriman(item.tracking_id)}
                            >
                              Detail
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {totalPages > 1 && (
                  <nav className="mt-4">
                    <ul className="pagination justify-content-end mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-start-pill"
                          onClick={() => handlePageChange(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={`page-logp-${index + 1}`}
                          className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link shadow-none"
                            onClick={() => handlePageChange(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                          className="page-link shadow-none rounded-end-pill"
                          onClick={() => handlePageChange(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-truck-loading mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Tidak Ada Data yang Sesuai</h5>
                <p className="mb-0">Coba ubah kata kunci pencarian atau sesuaikan pilihan filter status Anda.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogistikP;